#import "../../../../core/email-marketing/graphql/fragments/em-from-address-fragment.graphql"

mutation SharedEmailAddressAdd($input: SharedEmailAddressAddInput!) {
    sharedEmailAddressAdd(input: $input) {
        fromAddress {
            ...FromAddress
        }
    }
}
